import { render, staticRenderFns } from "./ConfigParamsEdit.vue?vue&type=template&id=deac83da&scoped=true"
import script from "./ConfigParamsEdit.vue?vue&type=script&lang=js"
export * from "./ConfigParamsEdit.vue?vue&type=script&lang=js"
import style0 from "./ConfigParamsEdit.vue?vue&type=style&index=0&id=deac83da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deac83da",
  null
  
)

export default component.exports